
import { inject, ref, toRefs } from 'vue'
import NcListItem from '@nextcloud/vue/components/NcListItem'
import ConversationIcon from './../../ConversationIcon.vue'
import { useConversationInfo } from '../../../composables/useConversationInfo.ts'

export default {
	name: 'ConversationSearchResult',

	components: {
		ConversationIcon,
		NcListItem,
	},

	props: {
		item: {
			type: Object,
			default() {
				return {
					token: '',
					participants: [],
					participantType: 0,
					unreadMessages: 0,
					unreadMention: false,
					objectType: '',
					type: 0,
					displayName: '',
					isFavorite: false,
					notificationLevel: 0,
				}
			},
		},
	},

	emits: ['click'],

	setup(props) {
		const { item } = toRefs(props)
		const selectedRoom = inject('selectedRoom', null)
		const exposeDescriptionRef = inject('exposeDescription', ref(false))
		const exposeMessagesRef = inject('exposeMessages', ref(false))
		const { counterType, conversationInformation } = useConversationInfo({
			item,
			exposeDescriptionRef,
			exposeMessagesRef,
		})

		return {
			selectedRoom,
			counterType,
			conversationInformation,
			exposeMessagesRef,
		}
	},

	methods: {
		onClick() {
			this.$emit('click', this.item)
		},
	},
}
